import "../SMSSolutions/SMSSolutions.css";
import {
  FaCheckCircle,
  FaUsers,
  FaProjectDiagram,
  FaBullseye,
  FaClock,
  FaBuilding,
  FaHandshake,
  FaTools,
  FaChartLine,
} from "react-icons/fa";
import centerImage from "../../pages/IVRSolutions/assets/ss.png";
import realEstateFlowImage from "./assets/realstate-flow.png";
const RealEstateTracking = () => {
  return (
    <>
      <div className="services-bannerff">
        <div className="overlayff"></div>
        <div className="contentff">
          <div className="lineff"></div>
          <div>
            <h1>Real Estate Tracking</h1>
            <p>
              In nowadays’s aggressive real estate marketplace, handling leads,
              deals, and performance manually is not effective. <br /> Our
              superior <b className="bold">real estate tracking</b> solutions
              assist retailers, brokers, and agencies in streamlining
              operations, <br />
              enhance productiveness, and closing deals more quickly.{" "}
            </p>
            <p>
              <span className="homeff">Home</span> → Service → Real Estate
              Tracking Solution
            </p>
          </div>
        </div>
      </div>
      <section className="ivr-section">
        <div className="ivr-container">
          <section className="about-sectionvv">
            <div className="about-containervv">
              <div className="about-contentvv">
                <span className="about-tagvv">Real Estate Tracking </span>

                <h1>What is Real Estate Tracking?</h1>

                <p className="about-descvv">
                  Real estate monitoring is a virtual device that allows
                  professionals reveal leads, deals, and common business overall
                  performance in actual time. It replaces traditional techniques
                  like spreadsheets with automated and shrewd solutions. Key
                  Points:
                </p>
                <div className="about-featuresvv">
                  <div className="feature-rightvv">
                    <p>
                      <FaCheckCircle /> Tracks belongings leads and customer
                      interactions
                    </p>
                    <p>
                      <FaCheckCircle /> Manages offers the use of{" "}
                      <b className="bold">real estate deal tracker </b>
                    </p>
                    <p>
                      <FaCheckCircle /> Organizes information through real
                      estate lead control systems
                    </p>
                    <p>
                      <FaCheckCircle /> Helps set and monitor targets with a
                      real estate goal tracker
                    </p>
                  </div>
                </div>
                <p>
                  With those gear, actual estate experts can make faster and
                  smarter decisions.
                </p>
                <br />
              </div>
            </div>
            <section className="services-bb">
              <div className="container-bb">
                <h5 className="subheading-bb">Real Estate Tracking  Flow</h5>
                <h2 className="heading-bb">Real Estate Tracking  Flow </h2>

                <div style={{ marginTop: "24px" }}>
                  <img
                    src={realEstateFlowImage}
                    alt="Real estate tracking flow diagram"
                    style={{ width: "100%", maxWidth: "1100px", height: "auto", display: "block", margin: "0 auto" }}
                  />
                </div>
              </div>
            </section>
            <section className="why-section">
              <div className="why-left">
                <span className="tags">Needs</span>

                <h1>Why Your Business Needs Real Estate Tracking </h1>
                <p>
                  In a quick-transferring enterprise like actual estate, lacking
                  a lead manner dropping revenue. That’s why having a robust
                  real estate monitoring machine is important.
                </p>
              </div>
              <br />
              <div className="why-container">
                <div className="why-right">
                  <div className="card">
                    <p>
                      <FaUsers className="why-icon" /> Better Lead Management with real property lead control
                    </p>
                  </div>
                  <div className="card">
                    <p>
                      <FaProjectDiagram className="why-icon" /> Deal Visibility the usage of a real estate deal
                      tracker{" "}
                    </p>
                  </div>
                  <div className="card">
                    <p>
                      <FaBullseye className="why-icon" /> Goal Achievement via a{" "}
                      <b className="bold">real estate goal tracker</b>
                    </p>
                  </div>
                  <div className="card">
                    <p><FaClock className="why-icon" /> Time Saving with automation</p>
                  </div>
                </div>
              </div>
            </section>
            <section className="why-sectionz">
              <h2>Key Features of Our Real Estate Tracking Solution</h2>

              <p className="why-descz">
                Our actual property monitoring platform is designed to simplify
                and optimize your workflow. Core Features:
              </p>

              <div className="why-containerz">
                <div className="why-gridz">
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle />
                      Lead Capture & Management with superior real estate lead
                      management
                    </p>
                    <p>
                      <FaCheckCircle />
                      Deal Pipeline Tracking the use of actual estate deal
                      tracker{" "}
                    </p>
                    <p>
                      <FaCheckCircle /> Goal Monitoring System with actual
                      estate goal tracker
                    </p>
                  </div>
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle /> Automated Reminders & Follow-ups
                    </p>
                    <p>
                      <FaCheckCircle /> Performance Analytics & Reports
                    </p>
                    <p>
                      <FaCheckCircle /> Cloud-Based Access Anytime, Anywhere
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="industriesss">
              <h2>Industries We Serve</h2>
              <p>
                Our <b className="bold">real estate tracking </b>solutions are
                perfect for:
              </p>
              <br />
              <div className="industries-containerss">
                <div className="industries-rightss">
                  <div className="cardss"><FaBuilding className="industry-icon" /> Real Estate Agencies </div>
                  <div className="cardss"><FaHandshake className="industry-icon" /> Property Dealers & Brokers </div>
                  <div className="cardss"><FaTools className="industry-icon" /> Builders & Developers </div>
                  <div className="cardss"><FaChartLine className="industry-icon" /> Real Estate Investors </div>
                  <div className="cardss"><FaUsers className="industry-icon" /> Sales & Lead Management Teams</div>
                </div>
              </div>
            </section>
            <section className="whyss">
              <p className="subtitless">WHY CHOOSE US</p>
              <h2 className="titless">
                Why Choose Our Real Estate Tracking Solution
              </h2>
              <p>
                We provide smart, reliable, and scalable actual property
                monitoring systems tailor-made for your business desires.
              </p>

              <div className="why-containerss">
                <div className="center-imagess">
                  <img src={centerImage} alt="transport" />
                </div>
                <div className="left-cardsss">
                  <div className="cardsss left-card card1">
                    <span> Easy-to-use dashboard <b>real estate lead management</b></span>
                  </div>
                  <div className="cardsss left-card card2">
                    <span> Real-time insights and reporting</span>
                  </div>
                </div>
                <div className="right-cards">
                  <div className="cardsss left-card card3">
                    <span> 24/7 help and help </span>
                  </div>
                  <div className="cardsss right-card card4">
                    <span>Real-time insights and reporting</span>
                  </div>
                </div>
              </div>
            </section>
          </section>
        </div>
      </section>
    </>
  );
};

export default RealEstateTracking;
